/** Utah's words for home/source-names.ts (generated by scripts/gen-home-source-names.ts). */
export const SOURCE_NAMES_UT = {
  /** How a research row that cites Utah's Food Code rule (R392-...) is named as a publisher. */
  stateRuleName: "Utah Food Code rule",
} as const;
